import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../../response.js';
import { acceptJson, authHeader } from '../../shared.js';
import { addressListSpec } from './specs.js';

const list = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { customerId , accessToken  }) {
        return validateResponse(addressListSpec, (yield fetch(`${apiUrl}/customers/customers/${encodeURIComponent(customerId)}/addresses`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return function list(apiUrl, _) {
        return _ref.apply(this, arguments);
    };
}();

export { list };
//# sourceMappingURL=list.js.map
